import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.876 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M30 14.958c0 4.178-1.795 7.385-5.706 9.307L24 24.41l-.294-.145C19.795 22.343 18 19.135 18 14.958v-3.625c0-.736.597-1.333 1.333-1.333h9.334c.736 0 1.333.597 1.333 1.333z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M29.333 14.958v-3.625a.667.667 0 0 0-.666-.666h-9.334a.667.667 0 0 0-.666.666v3.625c0 3.523 1.344 6.748 5.333 8.709 3.989-1.96 5.333-5.186 5.333-8.709",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M26.667 16c.736 0 1.333-.895 1.333-2s-.597-2-1.333-2c-.737 0-1.334.895-1.334 2s.597 2 1.334 2",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M24 21.333c1.105 0 2-.447 2-1s-.895-3.666-2-3.666-2 3.114-2 3.666c0 .553.895 1 2 1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9903C",
      fillRule: "evenodd",
      d: "M21.346 15.964c.54-.115.792-1.084.563-2.165s-.854-1.863-1.394-1.748-.792 1.084-.563 2.164.854 1.863 1.394 1.749",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FF9EE1",
      fillRule: "evenodd",
      d: "M21.181 15.964c-.54-.115-.792-1.084-.562-2.165s.854-1.863 1.394-1.748.792 1.084.562 2.164-.853 1.863-1.394 1.749",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTca = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTca_default = SvgFlagTca;

export { FlagTca_default as default };
